<template>
<div class="grid my-4" v-if="excerpt && uuid">

<div class="col-9">
<router-link  class="text-primary p-link no-underline font-bold" :to="{ name: 'UserNotification' , params: { notification_uuid:notification.suppliernotificationhandover.uuid }}">{{title}}</router-link>
</div>
<div class="col-3 text-right pt-2"><small class="text-purple-500">{{$filters.momentFormat( notification.created_at," DD-MM-YYYY HH:mm")}}</small></div>

<div class="col-12">
<div v-html="excerpt"></div>
</div>
<div class="col-12">
<div class="flex align-items-center justify-content-end ">
<Button :label="$store.state.languages.lang_phrases.goster" icon="pi pi-eye" class=" p-button-primary p-button-outlined  p-button-sm" @click="gotoNotification"></Button>
</div>
</div>
</div>
</template>

<script>
export default {

  name: 'SupplierNotificationDashboardWidget',
  props:["notification"],
  data () {
    return {

    }
  },
  computed:{
  	uuid()
  	{
  		if(this.notification.suppliernotificationhandover)
  		{
  			return this.notification.suppliernotificationhandover.uuid
  		}
  		return null
  	},
  	title()
  	{
  		if(this.notification.translations.length)
  		{
  			let translation = this.notification.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
  			if(translation)
  			{
  				return translation.translation
  			}
  			return  this.notification.name
  		}
  		return this.notification.name
  	},

  	excerpt()
  	{
  		if(this.notification.translations.length)
  		{
  			let translation = this.notification.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
  			if(translation)
  			{
  				return translation.excerpt
  			}
  			return  null
  		}
  		return null
  	},

  	message()
  	{
  		if(this.notification.translations.length)
  		{
  			let translation = this.notification.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
  			if(translation)
  			{
  				return translation.message
  			}
  			return  null
  		}
  		return null
  	},
  },
  methods:{
  	gotoNotification()
  	{
  		this.$router.push({ name: 'UserNotification', params: { notification_uuid:this.notification.suppliernotificationhandover.uuid } })
  	}
  },
}
</script>

<style lang="css" scoped>
</style>